<div class="fields__block__section" id="groups" [hidden]="hidden">

  <div class="title">
    <h4>Groups</h4><span> </span>
  </div>

  <div class="dropdown-fields">
    <div *ngIf="this.vg != undefined">
      <label for="visibility">Visibility</label>
      <select [(ngModel)]="this.vg" id="visibility" name="visibility" required>
        <ng-container *ngIf="gritUserService.groupPathsAvailable.includes(this.vg) || this.vg == ''; else otherVisibility">
            <option *ngFor="let group of gritUserService.groupPathsAvailable" [value]="group">{{ group }}</option>
        </ng-container>

        <ng-template #otherVisibility>
          <option [value]="this.vg">{{ this.vg }}</option>
        </ng-template>
      </select>
    </div>

    <div *ngIf="this.ag != undefined">
      <label for="access">Access</label>
      <select [(ngModel)]="this.ag" id="access" name="access" required>
        <ng-container *ngIf="gritUserService.groupPathsAvailable.includes(this.ag) || this.ag == ''; else otherAccess">
          <option *ngFor="let group of gritUserService.groupPathsAvailable" [value]="group">{{ group }}</option>
        </ng-container>

        <ng-template #otherAccess>
          <option [value]="this.ag">{{ this.ag }}</option>
        </ng-template>
      </select>
    </div>

    <div *ngIf="this.og != undefined">
      <label for="originator">Originator</label>
      <select [(ngModel)]="this.og" id="originator" name="originator" required>
        <ng-container *ngIf="gritUserService.groupPathsAvailable.includes(this.og) || this.og == ''; else otherOriginator">
          <option *ngFor="let group of gritUserService.groupsPaths" [value]="group">{{ group }}</option>
        </ng-container>

        <ng-template #otherOriginator>
          <option [value]="this.og">{{ this.og }}</option>
        </ng-template>
      </select>
    </div>
  </div>
</div>
